import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
// import ReactToPrint from "react-to-print";
// import Barcode from "react-barcode";
import _ from "lodash";
import moment from "moment";

// component
import {
  errorSwal,
  successDeleteSwal,
  successSwal,
  // warningSwal,
} from "../../../helper/sweetalert";
import {
  convertCurrency,
  covertTimeZone,
  numberFormat,
} from "../../../helper/index";
import PaginationHelper from "../../../components/PaginationHelper";
import AnimationLoading from "../../../components/Animationloading";
import EmptyComponent from "../../../components/EmptyComponent";
import AnimationStar from "../../../components/AnimationStar";
// import ConfirmDelete from "../../components/ConfirmDelete";
import CustomButton from "../../../components/CustomButton";
import {
  APP_COLOR,
  COLOR_RED_500,
  COLOR_WHITE,
  LINEAR_GRADIENT_BG,
  LINEAR_GRADIENT_BG_SP,
  S3_URL,
  SHOP_SETTING_KEY,
  UN_SELECTED_TAB_TEXT,
  USER_KEY,
} from "../../../const";

// apollo-client
import {
  CANCEL_STAR_PRODUCT,
  UPDATE_MANY_PRODUCT,
  UPDATE_START_PRODUCT,
} from "../../../apollo/product/Mutation";
import {
  DELETE_PRODUCT_VARIANT,
  UPDATE_PRODUCT_VARIANT,
  UPDATE_PRODUCT_VARIANT_MANY,
} from "../../../apollo/productVariant/mutation";
import { GET_SUBBRANDS } from "../../../apollo/subbrand/query";
import { GET_CATEGORYS } from "../../../apollo/category/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_PRODUCT_VARIANTS } from "../../../apollo/productVariant/query";
import { GET_BRANDS } from "../../../apollo/brand/Query";

// icon
import SearchIcon from "@mui/icons-material/Search";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import QrCode2Icon from "@mui/icons-material/QrCode2";
// import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
// import ClearAllIcon from "@mui/icons-material/ClearAll";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
// import PrintIcon from "@mui/icons-material/Print";
// import { BiBarcodeReader, BiCollapse } from "react-icons/bi";
// import { BiCollapseVertical } from "react-icons/bi";
// import { BiEdit } from "react-icons/bi";
import { AiFillEdit, AiOutlineStar } from "react-icons/ai";
import { AiFillStar } from "react-icons/ai";
// import EditIcon from "@mui/icons-material/Edit";
import { NumericFormat } from "react-number-format";
import { QRCode } from "react-qrcode-logo";

// react bootrap
import {
  Form,
  InputGroup,
  Modal,
  Offcanvas,
  Spinner,
  Table,
  Row,
  Col,
  Dropdown,
  Button,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addCategorytList } from "../../../redux/reducers/categoryReducer";
import ComfirmModal from "../../../components/ComfirmModal";
// import { Switch } from "antd";

// import BreadCrumbComponent from "../../components/BreadCrumbComponent";
import {
  MdAdd,
  // MdAspectRatio,
  MdDelete,
  MdDownload,
  MdOutlineAdd,
  MdOutlineCancel,
  MdOutlineDateRange,
  MdOutlineEditNote,
} from "react-icons/md";
import { BsFileExcel, BsFillXCircleFill } from "react-icons/bs";
import { FaCheckCircle } from "react-icons/fa";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import useWindowDimensions from "../../../helper/windowDimensions";
// import { ReactIcons } from "../../icons";
import { GET_SUVIVALS } from "../../../apollo/unit/Query";
import CurrentDateComponents from "../../../components/CurrentDateComponents";
import { useTranslation } from "react-i18next";

function ProductOption() {
  const { t } = useTranslation();
  const currentCategory = localStorage.getItem("CURRENT_CATEGORY");
  const currentBrand = localStorage.getItem("CURRENT_BRAND");
  const currentSubBrand = localStorage.getItem("CURRENT_SUBBRAND");

  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const shopSetting = JSON.parse(localStorage.getItem(SHOP_SETTING_KEY)) || {};
  const commissionEnable = shopSetting?.commissionEnable ?? false;
  const history = useHistory();
  const location = useLocation();
  const { height, width } = useWindowDimensions();

  const [selectedItems, setSelectedItems] = useState([]);
  const [product, setProduct] = useState({});

  const [productTotal, setProductTotal] = useState(0);
  const [selectCategory, setSelectCategory] = useState();
  const [brand, setBrand] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [showUpdateStar, setShowUpdateStar] = useState(false);
  const [Star, setStar] = useState();
  const [Delete, setDelete] = useState("");
  const [searchText, setSearchText] = useState("");
  const [searchBrand, setSearchBrand] = useState(currentBrand);
  const [isButton, setIsButton] = useState(false);
  const [searchCategory, setSearchCategory] = useState(currentCategory);
  const [showbarcodeMulti, setShowBarcodeMulti] = useState(false);

  const [searchSubbrand, setSearchSubbrand] = useState(currentSubBrand);
  const [showcolllap, setShowCollap] = useState(false);
  const [subBrand, setSubBrand] = useState();
  const [editTitle, setEditTitle] = useState();
  // const [editedAmount, setEditedAmount] = useState(numberFormat(products?.amount))
  const [showEditMany, setShowEditMany] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [showbarcode, setShowPrintBarcode] = useState();
  const [showbar, setShowBarPrint] = useState("");
  const [count, setCount] = useState(1); // initial count value is 1
  const ref = useRef();
  const { _limit, _skip, Pagination_helper } = PaginationHelper();
  const dispatch = useDispatch();
  const [isEditProducts, setIsEditProducts] = useState(false);
  const [isEditAmount, setIsEditAmount] = useState(false);
  const [editIndex, setEditIndex] = useState();
  const [getData, setGetData] = useState({ id: "", amount: "" });
  const [getSort, setGetSort] = useState({ id: "", sort: "" });
  const [barcodeMulti, setBarcodeMulti] = useState();
  const [isManyUpdate, setIsManyUpdate] = useState(false);
  const [branchUpdate, setBranchUpdate] = useState();
  const [categoryUpdate, setCategoryUpdate] = useState();
  const [quantity, setQuantity] = useState();
  const [originPrice, setOriginPrice] = useState();
  const [manyPrice1, setManyPrice1] = useState();
  const [manyPrice2, setManyPrice2] = useState();
  const [manyPrice3, setManyPrice3] = useState();
  const [sort, setSort] = useState();
  const [variantAmount, setVariantAmount] = useState();
  const [variantOriginPrice, setVariantOriginPrice] = useState();
  const [variantPrice, setVariantPrice] = useState();
  const [variantPromoPrice, setVariantPromoPrice] = useState();
  const [variantSort, setVariantSort] = useState();
  const [variantSalePageUpdate, setVariantSalePageUpdate] = useState(null);

  // get data from redux
  const { rolePermissions } = useSelector((state) => state.permissions);
  const { categoryList } = useSelector((state) => state.category);

  const [selectedOption, setSelectedOption] = useState("option1");

  const handleInputChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const [cateGogoriesData, setCategoriesData] = useState();
  const [dataPrintToBarcode, setDataPrintToBarcode] = useState([]);
  const [openActions, setOpenActions] = useState(false);
  const [validated, setValidated] = useState(false);

  const [updatedAmounts, setUpdatedAmounts] = useState({});
  const [updatedExpire, setUpdatedExpire] = useState("");
  const [updatedSort, setUpdatedSort] = useState({});
  const [userData, setUserData] = useState();
  const [survivalDatas, setSurvivalDatas] = useState([]);
  const [selectSurvival, setSelectSurvival] = useState();
  //FILTER_AMOUNT
  const [selectAmount, setSelectAmount] = useState("ALL");
  const [customAmount, setCustomAmount] = useState("");
  const [isCustom, setIsCustom] = useState(false);

  const [showQr, setShowQr] = useState(false);
  const salePageUrl = `https://sp.bbbb.com.la/shop/${shopId ?? ""}`;

  const handleCopySalePageLink = async () => {
    try {
      if (!shopId) {
        return errorSwal(t("pm_shop_not_found"));
      }
      await navigator.clipboard.writeText(salePageUrl);
      successSwal(t("pm_copy_salepage_success"));
    } catch (err) {
      errorSwal(t("pm_copy_failed"));
    }
  };

  const handleGenerateQr = () => {
    if (!shopId) {
      return errorSwal(t("pm_shop_not_found"));
    }
    setShowQr(true);
  };

  const handleDownloadQr = () => {
    try {
      const canvas = document.querySelector("#salepage-qr");
      if (!canvas) {
        return errorSwal(t("pm_qr_not_found"));
      }
      const url = canvas.toDataURL("image/png");
      const a = document.createElement("a");
      a.href = url;
      a.download = `shop-${shopId}-qr.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      errorSwal(t("pm_qr_download_failed"));
    }
  };

  const [showProductQr, setShowProductQr] = useState(false);
  const [productQrId, setProductQrId] = useState();
  const productDetailUrl = productQrId
    ? `https://salepage.packxi.shop/shop/${shopId}/product-detail?id=${productQrId}`
    : "";

  const handleCopyProductLink = async (id) => {
    try {
      if (!shopId) {
        return errorSwal(t("pm_shop_not_found"));
      }
      const url = `https://salepage.packxi.shop/shop/${shopId}/product-detail?id=${id}`;
      await navigator.clipboard.writeText(url);
      successSwal(t("pm_copy_product_success"));
    } catch (err) {
      errorSwal(t("pm_copy_failed"));
    }
  };

  const handleGenerateProductQr = (id) => {
    if (!shopId) {
      return errorSwal(t("pm_shop_not_found"));
    }
    setProductQrId(id);
    setShowProductQr(true);
  };

  const handleToggleSalePage = async (id, currentStatus) => {
    try {
      await updateProductVariant({
        variables: {
          where: { id: id },
          data: { isUsingSalePage: !currentStatus },
        },
      });
      successSwal(t("pm_salepage_update_success"));
      _filter();
    } catch (err) {
      errorSwal(t("pm_update_error"));
    }
  };

  // State select date
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [activeButton, setActiveButton] = useState("");
  const [filter, setFilter] = useState({
    createdAt_gte: "",
    createdAt_lt: "",
  });

  // State stock expire
  const [isExpire, setIsExpire] = useState(false);

  // ============== > UseLazyQuery And UseMutaion <==============

  const [
    LoadProductVariants,
    { data: GetProductVariantsData, loading: loadingVariants },
  ] = useLazyQuery(GET_PRODUCT_VARIANTS, { fetchPolicy: "cache-and-network" });


  const [LoadCategory, { data: GetCategoryData }] = useLazyQuery(
    GET_CATEGORYS,
    { fetchPolicy: "network-only" },
  );

  const [LoadBrand, { data: GetBrandData }] = useLazyQuery(GET_BRANDS, {
    fetchPolicy: "network-only",
  });

  const [LoadSubBrand, { data: GetSubBrandData }] = useLazyQuery(
    GET_SUBBRANDS,
    { fetchPolicy: "network-only" },
  );
  const [
    getSurvivalData,
    { loading: loadingSurvival, data: survivalDatasLoad },
  ] = useLazyQuery(GET_SUVIVALS, {
    fetchPolicy: "cache-and-network",
  });

  const [deleteProductVariant, { loading: loadingDelete }] =
    useMutation(DELETE_PRODUCT_VARIANT);

  const [updateProductStar, { loading: loadingStar }] =
    useMutation(UPDATE_START_PRODUCT);

  const [cancelProductStar, { loading: loadingCancelStar }] =
    useMutation(CANCEL_STAR_PRODUCT);

  const [updateManyProduct, { loading: loadingUpdateMany }] =
    useMutation(UPDATE_MANY_PRODUCT);

  const [updateProductVariant, { loading: loadingUpdateVariant }] =
    useMutation(UPDATE_PRODUCT_VARIANT);
  const [updateProductVariantMany, { loading: loadingUpdateVariantMany }] =
    useMutation(UPDATE_PRODUCT_VARIANT_MANY);

  // ============== > useEffect <==============
  
  const getFilteredProductVariants = (data) => {
    let filteredData = data || [];

    if (!_.isEmpty(searchText)) {
      filteredData = filteredData.filter((item) =>
        item?.product?.name?.toLowerCase().includes(searchText.toLowerCase()),
      );
    }

    if (!_.isEmpty(searchCategory) && searchCategory !== "ALL") {
      filteredData = filteredData.filter(
        (item) => item?.product?.category?.id === searchCategory,
      );
    }

    if (!_.isEmpty(searchBrand) && searchBrand !== "ALL") {
      filteredData = filteredData.filter(
        (item) => item?.product?.brand?.id === searchBrand,
      );
    }

    if (!_.isEmpty(searchSubbrand) && searchSubbrand !== "ALL") {
      filteredData = filteredData.filter(
        (item) => item?.product?.subbrand?.id === searchSubbrand,
      );
    }

    return filteredData;
  };

  useEffect(() => {
    if (GetProductVariantsData) {
      const filteredData = getFilteredProductVariants(
        GetProductVariantsData?.productVariants?.data || [],
      );

      setProduct(filteredData);
      setProductTotal(filteredData.length);
    }
  }, [
    GetProductVariantsData,
    searchText,
    searchCategory,
    searchBrand,
    searchSubbrand,
  ]);

  

  useEffect(() => {
    if (GetCategoryData) {
      const result = [...(GetCategoryData?.categories?.data || [])] // Create a shallow copy of the array
        .sort((a, b) => a?.name?.localeCompare(b?.name));

      dispatch(addCategorytList(result));
    }
  }, [GetCategoryData]);

  useEffect(() => {
    if (GetBrandData) {
      const result = GetBrandData?.brands?.data?.sort((a, b) =>
        a?.name?.localeCompare(b?.name),
      );
      setBrand(result);
      setSelectCategory(GetBrandData?.brands?.data?.category?.id);
    }
  }, [GetBrandData]);

  useEffect(() => {
    if (GetSubBrandData) {
      const result = GetSubBrandData?.subBrands?.data?.sort((a, b) =>
        a?.name?.localeCompare(b?.name),
      );
      setSubBrand(result);
    }
  }, [GetSubBrandData]);

  useEffect(() => {
    let localUserData = JSON.parse(localStorage.getItem("USER_DATA"));
    if (localUserData) {
      setUserData(localUserData?.data);
    }

    // TODO: Get all category
    if (categoryList.length === 0) {
      LoadCategory({
        variables: {
          limit: 100,
          where: {
            shop: shopId,
            isDeleted: false,
          },
        },
      });
    }

    _filter();
  }, [shopId]);

  useEffect(() => {
    if (
      isExpire ||
      filter ||
      selectSurvival ||
      searchText ||
      _skip ||
      selectAmount !== "ALL" ||
      customAmount !== "ALL"
    ) {
      _filter();
    } else {
      _filter();
      filterBrand();
      filterSubBrand();
    }
  }, [
    searchText,
    searchBrand,
    searchCategory,
    searchSubbrand,
    _skip,
    currentCategory,
    currentBrand,
    currentSubBrand,
    selectSurvival,
    isExpire,
    filter,
    selectAmount,
    customAmount,
    isCustom,
  ]);

  // filter brand with categoryId
  useEffect(() => {
    filterBrand();
    // filterSubBrand();
  }, [categoryUpdate]);

  useEffect(() => {
    // Get shop data from localStorage
    const userData = localStorage.getItem("SHOP_DATA");
    if (userData) {
      const locals = JSON.parse(userData);
      if (locals) {
        fetchSurvivalDatas(locals.id);
      }
    }
  }, []);

  useEffect(() => {
    if (survivalDatasLoad) {
      setSurvivalDatas(survivalDatasLoad?.survivals?.data || []);
    }
  }, [survivalDatasLoad]);

  // Fetch survival data based on shop ID
  const fetchSurvivalDatas = async (shopId) => {
    if (loadingSurvival) return; // Prevent re-triggering if already loading

    try {
      await getSurvivalData({
        variables: {
          where: {
            shop: shopId,
            status: true,
            isDeleted: false,
          },
        },
      });
    } catch (err) {
      console.log("Load survival error: ", err);
    }
  };

  const filterBrand = () => {
    let _where = {
      shop: shopId,
      isDeleted: false,
      // category: searchCategory
    };

    if (!_.isEmpty(searchCategory) && searchCategory !== "ALL") {
      _where = { ..._where, category: searchCategory };
    }

    if (!_.isEmpty(categoryUpdate) && categoryUpdate !== "ALL") {
      _where = { ..._where, category: categoryUpdate };
    }

    // TODO: Get all brand
    LoadBrand({
      variables: {
        // limit: 50,
        where: _where,
      },
    });
  };

  const filterSubBrand = async () => {
    let _where = {
      shop: shopId,
      isDeleted: false,
      // category: searchCategory
    };
    if (!_.isEmpty(searchBrand) && searchBrand !== "ALL") {
      _where = { ..._where, brand: searchBrand };
    }

    // TODO: Get all brand
    LoadSubBrand({
      variables: {
        // limit: 50,
        where: _where,
      },
    });
  };

  const buildProductVariantWhere = () => {
    const localShopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

    const normalizeDateRange = (range) => {
      if (!range?.createdAt_gte || !range?.createdAt_lt) return range;
      const startBase =
        typeof moment.tz === "function"
          ? moment.tz(range.createdAt_gte, "Asia/Bangkok")
          : moment(range.createdAt_gte).utcOffset(7);
      const endBase =
        typeof moment.tz === "function"
          ? moment.tz(range.createdAt_lt, "Asia/Bangkok")
          : moment(range.createdAt_lt).utcOffset(7);

      if (startBase.isSame(endBase, "day")) {
        return {
          ...range,
          createdAt_gte: startBase.startOf("day").toISOString(),
          createdAt_lt: startBase.endOf("day").toISOString(),
        };
      }
      return range;
    };

    const normalizedFilter = normalizeDateRange(filter);

    let _where = {
      shop: localShopId,
      isDeleted: false,
    };

    if (
      normalizedFilter?.createdAt_gte !== "" &&
      normalizedFilter?.createdAt_lt !== ""
    ) {
      _where = {
        ..._where,
        createdAt_gte: normalizedFilter?.createdAt_gte,
        createdAt_lt: normalizedFilter?.createdAt_lt,
      };
    }

    if (isCustom) {
      if (
        !isNaN(customAmount) &&
        customAmount !== "ALL" &&
        customAmount !== ""
      ) {
        _where = { ..._where, amount: parseInt(customAmount) };
      } else {
        return null;
      }
    } else if (selectAmount !== "ALL") {
      switch (selectAmount) {
        case "LESS_1":
          _where = { ..._where, amount_lte: 0 };
          break;
        case "MORE_10":
          _where = { ..._where, amount_gt: 10 };
          break;
        case "LESS_10":
          _where = { ..._where, amount_lt: 10 };
          break;
        case "EQUAL_10":
          _where = { ..._where, amount: 10 };
          break;
        case "MORE_30":
          _where = { ..._where, amount_gt: 30 };
          break;
        case "LESS_30":
          _where = { ..._where, amount_lt: 30 };
          break;
        case "EQUAL_30":
          _where = { ..._where, amount: 30 };
          break;
        case "MORE_50":
          _where = { ..._where, amount_gt: 50 };
          break;
        case "LESS_50":
          _where = { ..._where, amount_lt: 50 };
          break;
        case "EQUAL_50":
          _where = { ..._where, amount: 50 };
          break;
      }
    }

    return _where;
  };

  const _filter = async (_values) => {
    try {
      const _where = buildProductVariantWhere();
      if (!_where) return;

      const limitValue = !_.isEmpty(_values) ? parseInt(_values, 10) : _limit;

      LoadProductVariants({
        variables: {
          orderBy: "createdAt_DESC",
          skip: (_skip - 1) * _limit,
          limit: limitValue,
          where: _where,
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  useEffect(() => {
    const shouldRefresh = localStorage.getItem("REFRESH_PRODUCT_VARIANT");
    if (shouldRefresh === "1") {
      localStorage.removeItem("REFRESH_PRODUCT_VARIANT");
      _filter();
    }
  }, [location.key]);

  const handleShowDelete = (productVariant) => {
    setDelete(productVariant);
    setShowDelete(true);
  };

  const handleShowUpdateStar = (id, name) => {
    setStar({ name, id });
    setShowUpdateStar(true);
  };

  const handleShowbarcode = (id, barCode, name) => {
    setShowBarPrint({ barCode, id, name });
    setShowPrintBarcode(true);
  };

  const _confirmeDelete = async () => {
    try {
      if (loadingDelete) return;
      await deleteProductVariant({
        variables: {
          where: {
            id: Delete?.id,
          },
        },
      });
      _filter();
      successDeleteSwal(t("pm_delete_success"));
      setShowDelete(false);
    } catch (err) {
      errorSwal(t("pm_delete_failed"));
    }
  };

  const _confirmUpdateStar = async () => {
    try {
      if (loadingStar) return;
      await updateProductStar({
        variables: {
          where: {
            id: Star?.id,
          },
        },
      });
      _filter();
      successDeleteSwal(t("pm_star_success"));
      setShowUpdateStar(false);
    } catch (error) {
      errorSwal(t("pm_star_failed"));
    }
  };

  const _confirmCancelStar = async () => {
    try {
      if (loadingStar) return;
      await cancelProductStar({
        variables: {
          where: {
            id: Star?.id,
          },
        },
      });
      _filter();
      successDeleteSwal(t("pm_cancel_star_success"));
      setShowUpdateStar(false);
    } catch (error) {
      errorSwal(t("pm_cancel_star_failed"));
    }
  };

  const onUpdateManyStocks = async () => {
    try {
      if (loadingUpdateVariantMany) return;

      const newDataUpdate = {};
      if (variantAmount !== undefined && variantAmount !== null) {
        newDataUpdate.amount = parseInt(
          variantAmount.toString().replace(/,/g, "") || 0,
          10,
        );
      }
      if (variantOriginPrice !== undefined && variantOriginPrice !== null) {
        newDataUpdate.originPrice = parseFloat(
          variantOriginPrice.toString().replace(/,/g, "") || 0,
        );
      }
      if (variantPrice !== undefined && variantPrice !== null) {
        newDataUpdate.price = parseFloat(
          variantPrice.toString().replace(/,/g, "") || 0,
        );
      }
      if (variantPromoPrice !== undefined && variantPromoPrice !== null) {
        newDataUpdate.promoPrice = parseFloat(
          variantPromoPrice.toString().replace(/,/g, "") || 0,
        );
      }
      if (variantSort !== undefined && variantSort !== null) {
        newDataUpdate.sort = parseInt(
          variantSort.toString().replace(/,/g, "") || 0,
          10,
        );
      }
      if (variantSalePageUpdate !== null) {
        newDataUpdate.isUsingSalePage = variantSalePageUpdate;
      }

      const res = await updateProductVariantMany({
        variables: {
          where: {
            id_in: selectedItems,
          },
          data: newDataUpdate,
        },
      });

      if (res?.data?.updateProductVariantMany?.count) {
        setIsManyUpdate(false);
        setSelectedItems([]);
        setIsSelectAll(false);
        _filter();
        setVariantAmount(null);
        setVariantOriginPrice(null);
        setVariantPrice(null);
        setVariantPromoPrice(null);
        setVariantSort(null);
        setVariantSalePageUpdate(null);
        successSwal(t("pm_edit_success"));
      }
    } catch (error) {
      setValidated(false);
      console.log({ error });
    }
  };

  ///////////////////////////////////
  const _editManyProduct = async () => {
    try {
      await updateManyProduct({
        variables: {
          where: {
            id_in: selectedItems,
          },
          data: {
            subbrand: editTitle,
          },
        },
      });
      _filter();
      setSelectedItems([]);
      successSwal(t("pm_edit_all_success"));
      setShowEditMany(false);
      setEditTitle();
      setIsSelectAll(false);
    } catch (error) {
      console.log("error: ", error);
      throw Error(error);
    }
  };
  ///////////////////////////////////////

  const handleCheckboxChange = (event) => {
    const itemId = event.target.value;
    if (itemId !== "") {
      setIsEditProducts(true);
      setSelectedItems((prevSelectedItems) => {
        if (prevSelectedItems.includes(itemId)) {
          return prevSelectedItems.filter((id) => id !== itemId);
        } else {
          return [...prevSelectedItems, itemId];
        }
      });
    } else {
      setIsEditProducts(false);
    }
    console.log("Selected Items :", itemId);
  };

  // event handler for changing the count input
  const handleChangeCount = (event) => {
    setCount(Number(event.target.value)); // convert the input value to a number and update the count state
  };

  const handleChangeSubbrand = (event) => {
    setEditTitle(event.target.value);
  };

  const handleDeleteSelected = () => {
    try {
      const remainingItems = product.filter(
        (e) => !selectedItems.includes(e.id),
      );
      setProduct(remainingItems);
      setProductTotal(productTotal - selectedItems?.length);
      setSelectedItems([]);
      selectedItems.map(async (item) =>
        deleteProductVariant({
          variables: {
            where: {
              id: item,
            },
          },
        }),
      );
      setShowDelete(false);
      successSwal(t("pm_delete_all_success"));
    } catch (error) {
      errorSwal(error);
    }
  };

  //=========================================================
  const onSeletedAllProducts = async () => {
    if (isSelectAll) {
      setSelectedItems([]);
      setIsSelectAll(false);
    } else {
      let _dataForSelectAll = [];
      for (var i = 0; i < product.length; i++) {
        if (!product[i]?.isUsing) {
          _dataForSelectAll.push(product[i].id);
        }
      }
      setSelectedItems(_dataForSelectAll);
      setIsSelectAll(true);
    }

    return;
  };

  // change amounts
  const handleAmountChange = (event, _id, name, barCode, unit, currency) => {
    setIsEditAmount(true);
    setEditIndex(_id);
    const newAmount = event.target.value;
    setGetData({ id: _id, amount: newAmount, name, barCode, unit, currency });
    setUpdatedAmounts((prevState) => ({
      ...prevState,
      [_id]: newAmount,
    }));
  };
  const onGetsortChange = (event, _id, name, barCode, unit, currency) => {
    setIsEditAmount(true);
    setEditIndex(_id);
    const newSort = event?.target?.value;
    setGetSort({ id: _id, sort: newSort });
    setUpdatedSort((prevState) => ({
      ...prevState,
      [_id]: newSort,
    }));
  };

  const handleSubmit = async () => {
    try {
      if (loadingUpdateVariant) return;

      let _newData = {};

      if (getData?.amount) {
        _newData = {
          ..._newData,
          amount: isNaN(parseInt(getData?.amount, 10))
            ? 0
            : parseInt(getData?.amount, 10),
        };
      }

      if (getSort?.sort) {
        _newData = {
          ..._newData,
          sort: isNaN(parseInt(getSort?.sort, 10))
            ? 0
            : parseInt(getSort?.sort, 10),
        };
      }

      const res = await updateProductVariant({
        variables: {
          where: {
            id: getData?.id || getSort?.id,
          },
          data: _newData,
        },
      });

      if (res) {
        successSwal(t("pm_edit_product_success"));
        setIsEditAmount(false);
        _filter();
        setUpdatedAmounts({});
        setUpdatedSort({});
        setGetSort();
        setGetData();
      }
    } catch (error) {
      console.error("Error:", error);
      errorSwal(t("pm_error_try_again"));
      // Handle error
    }
  };

  const onCancelEditData = async () => {
    setIsEditAmount(false);
    setEditIndex();
    setUpdatedAmounts({});
    setUpdatedSort({});
  };

  const onButtonPrinbarcode = () => {
    setIsButton(!isButton);
  };
  const onShowCollaps = () => {
    setShowCollap(!showcolllap);
  };

  const handleCheckboxChangeCount = (event, index) => {
    const updatedItems = [...selectedItems];
    updatedItems[index].count = parseInt(event.target.value);
    setDataPrintToBarcode(updatedItems);
  };

  const onPrinBarcode = (data) => {
    setDataPrintToBarcode(data);
    setShowBarcodeMulti(true);
  };

  const translateDataFieldsToLao = (data) =>
    data.map((item) => ({
      ລະຫັດສິນຄ້າ: item?.barCode ?? item?.id ?? "-",
      ຊື່ສິນຄ້າ: item?.product?.name ?? "-",
      ຕົວເລືອກ:
        item?.attributeValues
          ?.map((av) => `${av?.attribute?.name}: ${av?.value}`)
          .join(" / ") || "-",
      ປະເພດ: item?.product?.category?.name ?? "-",
      ຍີ່ຫໍ້: item?.product?.brandName ?? "-",
      ເລກລຽງ: item?.sort ?? "-",
      ຈຳນວນ: numberFormat(item?.amount ?? 0),
      ລາຄາຕົ້ນທືນ:
        convertCurrency(item?.currency) + " " + numberFormat(item?.originPrice),
      ລາຄາຂາຍ:
        convertCurrency(item?.currency) + " " + numberFormat(item?.price),
      ວັນທີນຳເຂົ້າ: item?.createdAt
        ? covertTimeZone(item?.createdAt)
        : "-",
    }));

  const onDownloadToExcelFile = async () => {
    try {
      const tableData = GetProductVariantsData?.productVariants?.data || [];
      const translatedData = translateDataFieldsToLao(
        getFilteredProductVariants(tableData),
      );

      const workbook = XLSX.utils.book_new();
      const rows = [];

      translatedData.forEach((item, index) => {
        rows.push({
          ລຳດັບ: index + 1,
          ...item,
        });
      });

      const worksheet = XLSX.utils.json_to_sheet(rows);

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      XLSX.writeFile(workbook, `stock-data-variant-current-${_skip}.xlsx`);

      toast.success(t("pm_excel_download_success"), {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (error) {
      console.error({ error });
    }
  };

  const handleSelectLimit = (e) => {
    const _values = e?.target?.value;

    // Extract the current pathname
    let pathname = location.pathname;

    // Use regular expression to replace the limit value in the URL
    pathname = pathname.replace(/(\/limit\/)\d+/, `/limit/${_values}`);

    // Reset page to 1 whenever limit changes
    pathname = pathname.replace(/(\/page\/)\d+/, "/page/1");

    // Replace the current entry in the history stack
    history.replace(pathname);

    // Optionally, call the filterOrderGroups function if needed
    _filter(_values);
  };

  //FILTER_AMOUNT
  const amountChoice = [
    { value: "ALL", label: t("pm_select") },
    { value: "LESS_1", label: t("pm_amount_zero_neg") },
    { value: "MORE_10", label: t("pm_more_than") + " 10" },
    { value: "LESS_10", label: t("pm_less_than") + " 10" },
    { value: "EQUAL_10", label: t("pm_equal_to") + " 10" },
    { value: "MORE_30", label: t("pm_more_than") + " 30" },
    { value: "LESS_30", label: t("pm_less_than") + " 30" },
    { value: "EQUAL_30", label: t("pm_equal_to") + " 30" },
    { value: "MORE_50", label: t("pm_more_than") + " 50" },
    { value: "LESS_50", label: t("pm_less_than") + " 50" },
    { value: "EQUAL_50", label: t("pm_equal_to") + " 50" },
  ];

  const handleSelectChange = (e) => {
    const value = e.target.value;
    if (value === "custom") {
      setIsCustom(true);
      setSelectAmount("");
    } else {
      setIsCustom(false);
      setSelectAmount(value);
      setCustomAmount(value);
    }
  };

  const handleCustomChange = (e) => {
    const value = e.target.value;
    setCustomAmount(value);
    setSelectAmount(value);
  };

  const handleBackToSelect = (status) => {
    setCustomAmount(""); // Optional: clear custom input
    setSelectAmount("ALL");
    setIsCustom(status || false);
  };
  //FILTER_AMOUNT

  // check role and permission
  const isAdmin = userData?.role === "ADMIN";
  const isEditPermission = ["EDIT_STOCK", "DELETE_STOCK"].some((permission) =>
    rolePermissions.includes(permission),
  );

  const formatCommissionLines = (commissionPlatforms = []) => {
    if (!Array.isArray(commissionPlatforms) || commissionPlatforms.length === 0) {
      return ["-"];
    }

    return commissionPlatforms.map((platformInfo, index) => {
      const platformKey = platformInfo?.platform ?? "-";
      const platformLabel = platformKey === "POS" ? t("pm_pos_label") : platformKey === "ONLINE" ? t("pm_online_label") : platformKey;
      const commissionType = platformInfo?.commissionType;
      const value = numberFormat(platformInfo?.commissionValue ?? 0);
      const unit = commissionType === "PERCENT" ? "%" : "Kip";

      return `${platformLabel}: ${value} ${unit}`;
    });
  };

  return (
    <React.Fragment>
      <div>
        <Row className="g-2 align-items-center" style={{ padding: 10 }}>
          <Col xs={12} md={6}>
            <h4>
              <b>{t("pm_title_variant")}</b>
            </h4>
            <p>
              {t("pm_stock_info")}{" "}
              <b>[ {numberFormat(productTotal ?? 0)} ]</b> {t("pm_items")}.
            </p>
            <div className="d-flex align-items-center gap-2">
              <Form.Check.Input
                disabled={loadingVariants}
                type="checkbox"
                name="status"
                onChange={(e) => {
                  setIsExpire(e?.target?.checked);
                }}
                value={isExpire}
                checked={isExpire}
              />
              <Form.Check.Label>
                <span style={{ color: isExpire ? "green" : "black" }}>
                  {isExpire ? t("pm_selected") : t("pm_not_selected")}
                </span>
                : {t("pm_expire_label")}
              </Form.Check.Label>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6}>
            <Row className="g-2">
              {(isAdmin || isEditPermission) && (
                <>
                  <Col xs={4}>
                    <CustomButton
                      title={width > 700 ? t("pm_add_product_variant") : t("pm_add")}
                      icon={<MdAdd />}
                      width={"100%"}
                      borderRadius="5px"
                      background={LINEAR_GRADIENT_BG}
                      color={COLOR_WHITE}
                      onClick={() => history.push("/addproduct_option")}
                    />
                  </Col>
                </>
              )}
              <Col xs={4}>
                <CustomButton
                  title={showcolllap ? t("pm_hide_details") : t("pm_show_details")}
                  width={"100%"}
                  borderRadius="5px"
                  background={LINEAR_GRADIENT_BG}
                  color={COLOR_WHITE}
                  onClick={onShowCollaps}
                />
              </Col>
              {(isAdmin || isEditPermission) && (
                <>
                  <Col xs={4}>
                    <CustomButton
                      title={width > 700 ? t("pm_edit_many") : t("pm_edit")}
                      icon={<MdOutlineEditNote />}
                      width={"100%"}
                      borderRadius="5px"
                      background={
                        selectedItems?.length > 0 ? LINEAR_GRADIENT_BG : "#ddd"
                      }
                      color={selectedItems?.length > 0 ? "#fff" : "#888"}
                      onClick={() => {
                        if (selectedItems?.length > 0) {
                          setIsManyUpdate(true);
                        }
                      }}
                    />
                  </Col>
                  <Col xs={4}>
                    <CustomButton
                      title={width > 700 ? t("pm_delete_all") : t("pm_delete")}
                      icon={<MdDelete />}
                      width={"100%"}
                      borderRadius="5px"
                      background={
                        selectedItems?.length > 0 ? COLOR_RED_500 : "#ddd"
                      }
                      color={selectedItems?.length > 0 ? "#fff" : "#888"}
                      onClick={() =>
                        selectedItems?.length > 0
                          ? setShowDelete(true)
                          : errorSwal(t("pm_select_to_delete"))
                      }
                    />
                  </Col>
                  <Col xs={4}>
                    <CustomButton
                      title={width > 700 ? t("pm_download_excel") : "excel"}
                      icon={<MdDownload />}
                      width={"100%"}
                      borderRadius="5px"
                      background={LINEAR_GRADIENT_BG}
                      onClick={onDownloadToExcelFile}
                    />
                  </Col>
                </>
              )}
            </Row>
          </Col>
        </Row>
      </div>
      <Modal show={showQr} onHide={() => setShowQr(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>QR Sale Page</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: "center" }}>
            <QRCode id="salepage-qr" value={salePageUrl} size={256} />
            <p style={{ marginTop: 10, fontSize: 12 }}>{salePageUrl}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setShowQr(false)}>
            {t("pm_close")}
          </Button>
          <Button variant="success" onClick={handleDownloadQr}>
            {t("pm_download_qr")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showProductQr}
        onHide={() => setShowProductQr(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("pm_qr_product_link")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: "center" }}>
            <QRCode id="product-qr" value={productDetailUrl} size={256} />
            <p style={{ marginTop: 10, fontSize: 12, wordBreak: "break-all" }}>
              {productDetailUrl}
            </p>
            <div
              style={{
                marginTop: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
                cursor: "pointer",
              }}
              onClick={() => handleCopyProductLink(productQrId)}
            >
              <ContentCopyIcon style={{ fontSize: 18 }} />
              <span>{t("pm_copy")}</span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setShowProductQr(false)}
          >
            {t("pm_close")}
          </Button>
          <Button
            variant="success"
            onClick={() => {
              try {
                const canvas = document.querySelector("#product-qr");
                if (!canvas) {
                  return errorSwal(t("pm_qr_not_found"));
                }
                const url = canvas.toDataURL("image/png");
                const a = document.createElement("a");
                a.href = url;
                a.download = `product-${productQrId}-qr.png`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                successSwal(t("pm_qr_download_success"));
              } catch (err) {
                errorSwal(t("pm_qr_download_failed"));
              }
            }}
          >
            {t("pm_download_qr")}
          </Button>
        </Modal.Footer>
      </Modal>
      <div
        style={{
          margin: "0.5em",
          borderRadius: ".2em",
          overflow: "auto",
        }}
      >
        <Row className="g-2">
          <Col xs={6} md={6} lg={4}>
            <Form.Group>
              <Form.Label>{t("pm_search_data")}</Form.Label>
              <InputGroup>
                <InputGroup.Text id="basic-addon1">
                  <SearchIcon />
                </InputGroup.Text>
                <Form.Control
                  placeholder={t("pm_product_name_ph")}
                  aria-label="product-name"
                  aria-describedby="basic-addon1"
                  onChange={(e) => setSearchText(e?.target?.value)}
                  value={searchText}
                />
              </InputGroup>
            </Form.Group>
          </Col>

          <Col xs={6} md={6} lg={4}>
            <Form.Group>
              <Form.Label>{t("pm_category")}</Form.Label>
              <Form.Select
                style={{ height: "40px", color: "#6B7280", cursor: "pointer" }}
                onChange={(e) => {
                  setSearchCategory(e.target.value);
                  const getId = e?.target?.value;
                  const selectedCategory = categoryList.find(
                    (data) => data.id === getId,
                  );
                  if (selectedCategory) {
                    const categoryData = {
                      id: selectedCategory.id,
                      name: selectedCategory.name,
                    };
                    setCategoriesData(categoryData);
                    localStorage.setItem("CURRENT_CATEGORY", categoryData?.id);
                    localStorage.removeItem("CURRENT_BRAND");
                    setSearchBrand();
                  } else {
                    setCategoriesData("ALL");
                  }
                }}
                value={searchCategory}
              >
                <option value="ALL">{t("pm_select")}</option>
                {categoryList?.map((category) => (
                  <option key={category.id} value={category?.id}>
                    {category.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col xs={6} md={6} lg={4}>
            <Form.Group>
              <Form.Label>{t("pm_date")}</Form.Label>
              <Button
                variant="outline-secondary"
                onClick={() => setIsCurrentModals(true)}
                style={{ textAlign: "left", marginTop: "-.2em", width: "100%" }}
              >
                {loadingVariants ? (
                  <Spinner size="sm" />
                ) : (
                  <MdOutlineDateRange style={{ fontSize: 24 }} />
                )}
                &nbsp;&nbsp;
                {filter?.createdAt_gte === "" && filter?.createdAt_lt === "" ? (
                  <span style={{ fontSize: 14 }}>{t("pm_search_by_date")}</span>
                ) : (
                  <span style={{ fontSize: 14 }}>
                    {covertTimeZone(filter?.createdAt_gte) +
                      " - " +
                      covertTimeZone(filter?.createdAt_lt)}
                  </span>
                )}
              </Button>
            </Form.Group>
          </Col>

          <Col xs={6} md={6} lg={4}>
            <Form.Group>
              <Form.Label>{t("pm_brand")}</Form.Label>
              <Form.Select
                style={{ height: "40px" }}
                onChange={(e) => setSearchBrand(e?.target?.value)}
                value={searchBrand}
              >
                <option value="ALL">{t("pm_select")}</option>
                {brand?.map((brand, _index) => (
                  <option key={_index} value={brand?.id}>
                    {brand?.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          {/* <Col xs={6} md={6} lg={4}>
              <Form.Group>
                <Form.Label>ຊັບແແບຣນ</Form.Label>
                <Form.Select
                  style={{ height: "40px", color: "#6B7280", cursor: "pointer" }}
                  onChange={(e) => { setSearchSubbrand(e.target.value); }}
                  value={searchSubbrand}
                >
                  <option value="ALL">--ເລືອກ--</option>
                  {subBrand?.map((sub, index) => (
                    <option key={sub + index} value={sub?.id}>
                      {sub?.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col> */}

          <Col xs={6} md={6} lg={4}>
            <Form.Group>
              <Form.Label>{t("pm_lot_number")}</Form.Label>
              <Form.Select
                style={{ height: "40px" }}
                onChange={(e) => setSelectSurvival(e?.target?.value)}
                value={selectSurvival}
              >
                <option value="ALL">{t("pm_select")}</option>
                {survivalDatas?.map((survival, _index) => (
                  <option key={_index} value={survival?.id}>
                    {survival?.survivalNumber}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={3}>
            <Form.Group>
              {isCustom ? (
                <Button
                  variant="link"
                  size="sm"
                  onClick={() => handleBackToSelect(false)}
                >
                  {t("pm_select_amount")}
                </Button>
              ) : (
                <Button
                  variant="link"
                  size="sm"
                  onClick={() => handleBackToSelect(true)}
                >
                  {t("pm_type_amount")}
                </Button>
              )}
              {!isCustom && (
                <Form.Select
                  onChange={handleSelectChange}
                  value={selectAmount || ""}
                  style={{ height: "40px" }}
                >
                  {amountChoice?.map((amount, index) => (
                    <option key={index} value={amount?.value}>
                      {amount?.label}
                    </option>
                  ))}
                  <option value="custom">{t("pm_type_amount")}</option>
                </Form.Select>
              )}
              {isCustom && (
                <Form.Control
                  type="text"
                  placeholder={t("pm_enter_custom_amount")}
                  value={customAmount}
                  onChange={handleCustomChange}
                  style={{ height: "40px", marginBottom: "8px" }}
                />
              )}
            </Form.Group>
          </Col>
        </Row>
      </div>

      {loadingVariants && !GetProductVariantsData ? (
        <AnimationLoading />
      ) : (
        <>
          {product?.length > 0 ? (
            <Table
              hover
              style={{
                marginTop: "20px",
                borderCollapse: "collapse",
                width: "100% ",
                cursor: "pointer",
                background: "#ffff",
              }}
              responsive
            >
              <thead
                style={{
                  background: LINEAR_GRADIENT_BG,
                  borderRadius: " 8px 8px 0px 0px",
                  color: "#FFFFFF",
                }}
              >
                <tr>
                  <th>
                    <Form.Check
                      aria-label="option 1"
                      checked={isSelectAll}
                      onClick={() => onSeletedAllProducts()}
                      label="#"
                    />
                  </th>
                  <th>{t("pm_th_image")}</th>
                  <th style={{ minWidth: 180 }}>{t("pm_th_product_name")}</th>
                  <th style={{ minWidth: 180 }}>{t("pm_th_barcode")}</th>
                  {showcolllap && <th style={{ minWidth: 100 }}>{t("pm_th_sort")}</th>}
                  <th style={{ minWidth: 100 }}>{t("pm_th_category")}</th>
                  <th style={{ minWidth: 100 }}>{t("pm_th_quantity")}</th>
                  <th style={{ minWidth: 100 }}>{t("pm_th_cost_price")}</th>
                  <th style={{ minWidth: 100 }}>{t("pm_th_sell_price")}</th>
                  {showcolllap ? (
                    <>
                      <th>{t("pm_th_sell_price2")}</th>
                      <th>{t("pm_th_sell_price3")}</th>
                      {commissionEnable && <th style={{ minWidth: 140 }}>{t("pm_th_commission")}</th>}
                    </>
                  ) : (
                    ""
                  )}
                  <th style={{ minWidth: 100 }}>{t("pm_th_import_date")}</th>
                  <th style={{ minWidth: 100 }}>{t("pm_th_salepage")}</th>
                  <th>{(isAdmin || isEditPermission) && t("pm_th_manage")}</th>
                </tr>
              </thead>
              <tbody>
                {product?.map((products, pindex) => (
                  <tr key={pindex}>
                    <td style={{ paddingTop: "1rem" }}>
                      <Form.Check
                        aria-label="option 1"
                        value={products?.id}
                        checked={selectedItems.includes(products?.id)}
                        onChange={handleCheckboxChange}
                        label={pindex + 1 + _limit * (_skip - 1)}
                      />
                    </td>
                    <td style={{ paddingTop: "1rem" }}>
                      {products?.image && products?.image.length > 0 ? (
                        <img
                          src={`${S3_URL}${products?.image[0]}`}
                          alt={products?.product?.name}
                          style={{
                            width: 60,
                            height: 60,
                            objectFit: "cover",
                            borderRadius: 4,
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: 60,
                            height: 60,
                            backgroundColor: "#f3f4f6",
                            borderRadius: 4,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 10,
                            color: "#9ca3af",
                          }}
                        >
                          No Image
                        </div>
                      )}
                    </td>
                    <td
                      style={{ paddingTop: "1rem" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {setIsEditProducts === false ? (
                        <Form.Control
                          type="text"
                          name="ip"
                          style={{ width: "200px" }}
                          value={products?.product?.name}
                        />
                      ) : (
                        <>
                          {products?.product?.name ?? "-"}
                          <br />
                          <small style={{ color: "#666" }}>
                            {products?.attributeValues
                              ?.map(
                                (av) => `${av?.attribute?.name}: ${av?.value}`,
                              )
                              .join(" / ") || ""}
                          </small>
                        </>
                      )}
                    </td>
                    <td style={{ paddingTop: "1rem" }}>
                      {products?.barCode ?? "-"}
                    </td>
                    {showcolllap && (
                      <td>
                        {isAdmin || isEditPermission ? (
                          <input
                            className="form-control"
                            type="text"
                            value={
                              updatedSort[products?.id] !== undefined
                                ? updatedSort[products?.id]
                                : numberFormat(products?.sort)
                            }
                            onChange={(event) =>
                              onGetsortChange(
                                event,
                                products?.id,
                                products?.name,
                                products?.barCode,
                              )
                            }
                            style={{
                              // border: "none",
                              minWidth: 70,
                              width: 70,
                            }}
                          />
                        ) : (
                          <span>{products?.sort ?? "-"}</span>
                        )}
                      </td>
                    )}

                    <td style={{ paddingTop: "1rem" }}>
                      {products?.product?.category?.name ?? "-"}
                    </td>
                    <td>
                      {isAdmin || isEditPermission ? (
                        <input
                          className="form-control"
                          type="text"
                          value={
                            updatedAmounts[products?.id] !== undefined
                              ? updatedAmounts[products?.id]
                              : numberFormat(products?.amount)
                          }
                          onChange={(event) =>
                            handleAmountChange(
                              event,
                              products?.id,
                              products?.name,
                              products?.barCode,
                              products?.currency,
                            )
                          }
                          style={{
                            minWidth: 70,
                            width: 70,
                            color: products?.amount <= 5 ? "red" : "black",
                          }}
                        />
                      ) : (
                        <span>{products?.amount}</span>
                      )}
                    </td>

                    <td style={{ paddingTop: "1rem" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <span>
                          {convertCurrency(products?.currency || "LAK")}
                        </span>
                        <span>{numberFormat(products?.originPrice || 0)}</span>
                      </div>
                    </td>
                    
                    <td style={{ paddingTop: "1rem" }}>
                      {convertCurrency(products?.currency)} &nbsp;
                      {numberFormat(products?.price ?? 0)}
                    </td>

                    {showcolllap && <td style={{ paddingTop: "1rem" }}>-</td>}
                    {showcolllap && <td style={{ paddingTop: "1rem" }}>-</td>}
                    {showcolllap && commissionEnable && (
                      <td style={{ paddingTop: "1rem", fontSize: 12 }}>
                        {formatCommissionLines(
                          products?.product?.commissionPlatforms || products?.commissionPlatforms,
                        ).map((line, index) => (
                          <div key={`${products?.id}-commission-${index}`}>{line}</div>
                        ))}
                      </td>
                    )}

                    <td style={{ paddingTop: "1rem" }}>
                      {covertTimeZone(products?.createdAt)}
                    </td>
                    {/* {showcolllap && <td style={{ paddingTop: "1rem" }}>-</td>} */}

                    <td style={{ paddingTop: "1rem" }}>
                      <div style={{ display: "flex", gap: 6, alignItems: 'center' }}>
                        <CustomButton
                          width="36px"
                          height="36px"
                          borderRadius="8px"
                          textalign="center"
                          background="#8f8f8f"
                          icon={<QrCode2Icon />}
                          onClick={() => handleGenerateProductQr(products?.id)}
                        />
                        <Form.Check
                          type="switch"
                          id={`sale-page-switch-${products.id}`}
                          checked={products.isUsingSalePage}
                          onChange={() => handleToggleSalePage(products.id, products.isUsingSalePage)}
                          title={products.isUsingSalePage ? t("pm_close_salepage") : t("pm_open_salepage_action")}
                        />
                      </div>
                    </td>
                    <td onClick={(e) => e.stopPropagation()}>
                      {isEditAmount && editIndex === products?.id ? (
                        <div>
                          <Button
                            variant="outline-primary"
                            onClick={handleSubmit}
                          >
                            <CreateIcon />
                          </Button>

                          <Button
                            variant="outline-danger"
                            onClick={onCancelEditData}
                            style={{ marginLeft: "10px" }}
                          >
                            <BsFillXCircleFill />
                          </Button>
                        </div>
                      ) : (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {(isAdmin || isEditPermission) && (
                            <CustomButton
                              width="36px"
                              height="36px"
                              borderRadius="8px"
                              textalign="center"
                              background="#F7F7F7"
                              icon={
                                products?.star === true ? (
                                  <AiFillStar
                                    size={"fa-5x"}
                                    style={{ color: "#19C332" }}
                                  />
                                ) : (
                                  <AiOutlineStar
                                    size={"fa-5x"}
                                    style={{ color: "#19C332" }}
                                  />
                                )
                              }
                              onClick={() =>
                                handleShowUpdateStar(
                                  products?.id,
                                  products?.name,
                                )
                              }
                            />
                          )}
                          &ensp;
                          {(isAdmin || isEditPermission) && (
                            <CustomButton
                              width="36px"
                              height="36px"
                              borderRadius="8px"
                              textalign="center"
                              background="#F7F7F7"
                              icon={<CreateIcon sx={{ color: "#19C332" }} />}
                              onClick={() => {
                                history.push(`/editproduct_variant`, {
                                  state: products,
                                });
                              }}
                            />
                          )}
                          &ensp;
                          {(isAdmin || isEditPermission) && (
                            <CustomButton
                              width="36px"
                              height="36px"
                              margin="0"
                              borderRadius="8px"
                              background="#F7F7F7"
                              color="#DC2626"
                              icon={<DeleteIcon sx={{ color: "#D21C1C" }} />}
                              onClick={() => handleShowDelete(products)}
                            />
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div style={{ padding: "3em 0" }}>
              {product?.length <= 0 && (
                <div
                  style={{
                    fontSize: "24px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#6B7280",
                    fontWeight: "400",
                    backgroundColor: "#fff",
                  }}
                >
                  <EmptyComponent />
                  <p>
                    <b>{t("pm_no_products")}</b>
                  </p>
                </div>
              )}
            </div>
          )}

          {productTotal > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "start",
                width: "100%",
              }}
            >
              <div />
              <div className="d-flex gap-2">
                <Form.Group
                  style={{ minWidth: 90 }}
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Select
                    aria-label="select-limit"
                    value={String(_limit)}
                    onChange={(e) => handleSelectLimit(e)}
                  >
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="85">85</option>
                    <option value="100">100</option>
                    <option value="300">300</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                  </Form.Select>
                </Form.Group>
                {Pagination_helper(productTotal, "", ``)}
              </div>
            </div>
          )}
        </>
      )}

      {/* end table */}

      {/* end delete modal */}
      <ComfirmModal
        showConfirmModal={showDelete}
        handleCancel={() => setShowDelete(false)}
        handleConfirm={
          selectedItems?.length > 0 ? handleDeleteSelected : _confirmeDelete
        }
        title={t("pm_warning")}
        text={
          selectedItems?.length > 0
            ? t("pm_confirm_delete_selected")
            : t("pm_confirm_delete_item") +
              ` ${Delete?.product?.name || Delete?.name || ""}` +
              ` ` + t("pm_confirm_delete_suffix")
        }
      />

      {/* modal show UpdateStar */}

      <Modal
        show={isManyUpdate}
        centered
        onHide={() => {
          setIsManyUpdate(false);
          setBranchUpdate();
          setQuantity();
          setVariantAmount(null);
          setVariantOriginPrice(null);
          setVariantPrice(null);
          setVariantPromoPrice(null);
          setVariantSort(null);
          setVariantSalePageUpdate(null);
        }}
        keyboard={false}
      >
        <Modal.Header>
          <h5>
            <b>{t("pm_edit_many_title")}</b>
          </h5>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row} className="mb-3" controlId="variant-amount">
            <Form.Label column>{t("pm_th_quantity")}</Form.Label>
            <Col sm="8">
              <NumericFormat
                name="variantAmount"
                min={0}
                className="form-control"
                value={variantAmount}
                onChange={(e) => setVariantAmount(e?.target?.value)}
                placeholder={t("pm_th_quantity")}
                thousandSeparator={true}
                prefix={""}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="variant-origin-price">
            <Form.Label column>{t("pm_th_cost_price")}</Form.Label>
            <Col sm="8">
              <NumericFormat
                name="variantOriginPrice"
                min={0}
                className="form-control"
                onChange={(e) => setVariantOriginPrice(e?.target?.value)}
                placeholder={t("pm_th_cost_price")}
                value={variantOriginPrice}
                thousandSeparator={true}
                prefix={""}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="variant-price">
            <Form.Label column>{t("pm_th_sell_price")}</Form.Label>
            <Col sm="8">
              <NumericFormat
                name="variantPrice"
                min={0}
                className="form-control"
                value={variantPrice}
                onChange={(e) => setVariantPrice(e?.target?.value)}
                placeholder={t("pm_price_ph")}
                thousandSeparator={true}
                prefix={""}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="variant-promo-price">
            <Form.Label column>{t("pm_th_promo_price")}</Form.Label>
            <Col sm="8">
              <NumericFormat
                name="variantPromoPrice"
                min={0}
                className="form-control"
                value={variantPromoPrice}
                onChange={(e) => setVariantPromoPrice(e?.target?.value)}
                placeholder={t("pm_promo_price_ph")}
                thousandSeparator={true}
                prefix={""}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="variant-sort">
            <Form.Label column>{t("pm_th_sort")}</Form.Label>
            <Col sm="8">
              <NumericFormat
                name="variantSort"
                min={0}
                className="form-control"
                value={variantSort}
                onChange={(e) => setVariantSort(e?.target?.value)}
                placeholder="0"
                thousandSeparator={true}
                prefix={""}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="variant-salepage">
            <Form.Label column>{t("pm_open_salepage_action")}</Form.Label>
            <Col sm="8" className="d-flex align-items-center">
              <Form.Check
                type="switch"
                id="variant-sale-page-switch"
                checked={variantSalePageUpdate === true}
                onChange={(e) => setVariantSalePageUpdate(e.target.checked)}
              />
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="d-flex gap-2">
          <CustomButton
            onClick={() => setIsManyUpdate(false)}
            icon={<MdOutlineCancel />}
            background="#f2f2f2"
            color={APP_COLOR}
            borderRadius={4}
            title={t("pm_cancel")}
            width="auto"
            padding="10px 20px"
          />
          <CustomButton
            onClick={onUpdateManyStocks}
            type="submit"
            icon={<FaCheckCircle />}
            background={LINEAR_GRADIENT_BG}
            color={"#fff"}
            borderRadius={4}
            title={t("pm_confirm")}
            // disabled={quantity ? false : true}
            width="auto"
            padding="10px 20px"
          />
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUpdateStar}
        centered
        onHide={() => setShowUpdateStar(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <div>{t("pm_confirm_best_seller")}</div>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "20px 0px 20px 0px",
              flexDirection: "column",
            }}
          >
            <div>
              <AnimationStar />
            </div>
            <div style={{ textAlign: "center" }}>
              <h5>
                {t("pm_best_seller_question")}{" "}
                <span style={{ color: "#111827", fontWeight: "bold" }}>
                  {Star?.name}
                </span>{" "}
                {t("pm_best_seller_question2")}
              </h5>
            </div>
            <div
              style={{
                display: "flex",
                marginTop: 30,
                justifyContent: "center",
              }}
            >
              <CustomButton
                title={loadingCancelStar ? <Spinner /> : t("pm_cancel")}
                color="#334155"
                fontweight={600}
                width="150px"
                border="1px solid #EEEEEE"
                borderRadius="8px"
                background="#f2f3f3"
                onClick={() => _confirmCancelStar()}
              />
              &emsp;
              <CustomButton
                title={loadingStar ? <Spinner /> : t("pm_confirm")}
                width={150}
                borderRadius={8}
                onClick={() => _confirmUpdateStar()}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* create Print */}

      <Modal
        show={showEditMany}
        onHide={() => {
          setShowEditMany(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>ເເກ້ໄຂຂໍ້ມູນທັງໝົດທິເລືອກ</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Select
            aria-label="Default select example"
            value={editTitle}
            onChange={handleChangeSubbrand}
          >
            <option>{t("pm_select_sub_brand")}</option>
            {subBrand?.map((sub, SuBindex) => (
              <option value={sub?.id} key={SuBindex}>
                {sub?.name}
              </option>
            ))}
          </Form.Select>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <CustomButton
              title={t("pm_save")}
              width={150}
              borderRadius={8}
              height={40}
              onClick={() => _editManyProduct()}
            />
          </div>
        </Modal.Body>
      </Modal>

      {/* print barcode */}

      <Offcanvas
        show={openActions}
        onHide={() => setOpenActions(false)}
        backdrop={false}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{t("pm_action_title")}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul style={{ padding: "0px" }} onClick={() => setOpenActions(false)}>
            <li
              className="menu-action-items"
              onClick={() => history.push("/addproduct")}
            >
              <MdOutlineAdd style={{ fontSize: 27 }} />
              <p>{t("pm_add_product")}</p>
            </li>
            {/* <li
              className="menu-action-items"
              onClick={() => setShowCollap(!showcolllap)}>
              <MdAspectRatio style={{ fontSize: 24 }} />
              <p>{showcolllap ? " ສະແດງລາຄາໜ້ອຍລົງ" : " ສະແດງລາຄາທັງໝົດ"}</p>
            </li> */}
            <li
              className="menu-action-items"
              onClick={() =>
                selectedItems?.length > 0
                  ? setShowDelete(true)
                  : errorSwal(t("pm_select_to_delete"))
              }
            >
              <MdDelete style={{ fontSize: 27 }} />
              <p>
                {selectedItems?.length > 0
                  ? t("pm_delete_all_products") + " " + `(${selectedItems?.length})` + " " + t("pm_items")
                  : t("pm_delete_all_products")}
              </p>
            </li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
      {/* //TODO Modal select date lenght */}
      <CurrentDateComponents
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setFilter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
      />
    </React.Fragment>
  );
}

export default ProductOption;
